module.exports = __webpack_public_path__ + "v1.2.5.20250227/img/phone.9aae3b1a.png";